<div class="simple-dialog">
  <div class="simple-dialog__header">
    <h2 class="simple-dialog__title">{{title}}</h2>
  </div>
  <app-monospaced-block>{{crl}}</app-monospaced-block>
  <div class="simple-dialog__actions">
    <button
      type="button"
      mat-button
      [mat-dialog-close]
      class="simple-dialog__button simple-dialog__button_primary">
      {{labels.ok}}
    </button>
  </div>
</div>
